<template >
    
  <v-app style='background-color: #f8f8f8;'>
    <Header/>
    <div style="z-index:1;">
      <v-container  style="margin-top: 75px!important;">
      <!-- <v-container class="grey lighten-5" style="margin-top: 75px!important;"> -->
        <v-row>
          <v-col v-if="!is_moder_view" style="max-width: 25%; width: 25%;">
            <v-row style="width: 100%;">
              <v-img
                :src="logo"
                class="logo zoom-image"
                aspect-ratio="0.9"
                style="width: 100%; margin-bottom: 30px;"
              ></v-img>
            </v-row>
            <v-row class="mr-0">
              <v-card style="width: 100%;">
                <div>
                  <v-list 
                    dense 
                    style="border-radius: 13px!important;"
                    v-model="current_tab_id"
                  >
                    <v-list-item
                        style="color: #fb8c00 !important; caret-color: #fb8c00 !important;"
                        :key=1
                        @click='choose_tab("personal-data")'
                        color="warning"
                    >
                        <v-list-item-title style="font-size: 16px;" v-text="'Регистрация / Личный кабинет'"></v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-for="([title, tab_name, icon, key]) in site_tab_new"
                      :key="key"
                      @click='choose_tab(tab_name)'
                      :style="current_site_tab == tab_name ? 'color: #1976d2 !important; caret-color: #1976d2 !important;': ''"
                    >
                      <v-list-item-title  v-text="title" :color="'success'"></v-list-item-title>

                    </v-list-item>

                    <v-list-group
                      :value="true"
                    >
                      <template v-slot:activator>
                        <v-list-item-title>Архив</v-list-item-title>
                      </template>

                      <v-list-group
                        :value="true"
                        no-action
                        sub-group
                      >
                        <template v-slot:activator>
                          <v-list-item-content>
                            <v-list-item-title>2025</v-list-item-title>
                          </v-list-item-content>
                        </template>

                        <v-list-item
                          v-for="([title, tab_name, icon,key]) in archive_25"
                          :key="key"
                          @click='choose_tab(tab_name)'
                          :color="current_site_tab == tab_name ? 'success' : 'primary'"
                          :style="current_site_tab == tab_name ? 'color: #1976d2 !important; caret-color: #1976d2 !important;': ''"
                          link
                        >
                          <v-list-item-title v-text="title"></v-list-item-title>

                        </v-list-item>
                      </v-list-group>

                      <v-list-group
                        :value="true"
                        no-action
                        sub-group
                      >
                        <template v-slot:activator>
                          <v-list-item-content>
                            <v-list-item-title>2024</v-list-item-title>
                          </v-list-item-content>
                        </template>

                        <v-list-item
                          v-for="([title, tab_name, icon,key]) in archive_24"
                          :key="key"
                          @click='choose_tab(tab_name)'
                          :color="current_site_tab == tab_name ? 'success' : 'primary'"
                          :style="current_site_tab == tab_name ? 'color: #1976d2 !important; caret-color: #1976d2 !important;': ''"
                          link
                        >
                          <v-list-item-title v-text="title"></v-list-item-title>

                        </v-list-item>
                      </v-list-group>

                      <v-list-group
                        :value="true"
                        no-action
                        sub-group
                      >
                        <template v-slot:activator>
                          <v-list-item-content>
                            <v-list-item-title>2023</v-list-item-title>
                          </v-list-item-content>
                        </template>

                        <v-list-item
                          v-for="([title, tab_name, icon,key]) in archive_23"
                          :key="key"
                          @click='choose_tab(tab_name)'
                          :color="current_site_tab == tab_name ? 'success' : 'primary'"
                          :style="current_site_tab == tab_name ? 'color: #1976d2 !important; caret-color: #1976d2 !important;': ''"
                          link
                        >
                          <v-list-item-title v-text="title"></v-list-item-title>

                        </v-list-item>
                      </v-list-group>
                    </v-list-group>
                  </v-list>
                </div>

              </v-card>
            </v-row>
          </v-col>
          <v-col :class="is_moder_view ? 'col-100' : 'col-75'">
          <!-- <v-col :class="is_moder_view ? 'col-100' : 'col-75'"  style="max-width: 75%; width: 75%;"> -->
            <v-row>
              <h1 id="name" itemprop="name" style="padding-top: 15px; text-align: center; width: 100%;"> 
                <em style="color: #08754d; font-size: 22px; padding-left: 5px !important;">IV Международный форум природоподобных технологий</em>
                <br>
                <br>
                <b class="pt-2" style="color: #185ba6; font-size: 30px; padding-left: 5px !important;">Курчатовский форум «Исследования с применением синхротронного излучения, нейтронов и электронов»</b>
              </h1>
              <h2 v-if="is_history" id="name" itemprop="name" style="padding-top: 60px; text-align: center; width: 100%;"> 
                <b style="color: #fb8611; padding-left: 5px !important;">архив {{ hist_year }} года</b>
              </h2>
              <h2 v-else id="name" itemprop="name" style="padding-top: 25px; text-align: center; width: 100%;"> 
                <b style="color: #185ba6; padding-left: 5px !important;">11 - 13 ноября 2026 года</b>
                <br>
                <!-- <b style="color: #185ba6; padding-left: 5px !important;">г. Москва, площадь Академика Курчатова, д.1, c.348</b> -->
                <b style="color: #185ba6; padding-left: 5px !important;">г. Москва, ул. Рогова д.1, Дом учёных им. академика А.П. Александрова</b>
                <br>
                <b style="color: #185ba6; padding-left: 5px !important;">НИЦ «Курчатовский институт»</b>
              </h2>
            </v-row>
            <v-row class="mt-5">
              <div style="width: 100%;">
                <router-view/>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-dialog v-model="GETTERS_OVERLAY">
        <v-overlay :value="GETTERS_OVERLAY">
            <v-progress-circular
                size="64"
                indeterminate
                color="grey"
            ></v-progress-circular>
        </v-overlay>
    </v-dialog>

    <div style="position: fixed; top: 48px; left: 0; width: 100%; z-index: 0;">
    <!-- <div style="width: 100%; height: 100%; position: sticky; top:50;"> -->
    <!-- <div style="width: 100%; height: 100%; position: absolute; top:50; left:0;"> -->
      <vue-particles
        color='#65d1ea'
        :particleOpacity="0.7"
        :particlesNumber="150"
        shapeType="circle"
        :particleSize="4"
        linesColor='#65d1ea'
        :linesWidth="2"
        :lineLinked="true"
        :lineOpacity="0.3"
        :linesDistance="120"
        :moveSpeed="2"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
    </div>

  </v-app>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import Header from './components/Common/Header.vue'
import axios from 'axios';
import { AUTH_URL, REFERENCES_URL, CURRENT_MEETING_ID } from '../vars';
import logo from '../src/assets/logo-26-1.png';


export default {
  name: 'App',
  components: {
    Header,
  },
  data() {
    return {
      is_moder_view: false,
      is_history: false,
      archive: '',
      logo,
      current_site_tab: '',
      current_tab_id: 5,

      archive_23: [
        ['Программа', 'program_23', 'mdi-account-multiple-outline',101],
        ['Участники', 'users_23', 'mdi-cog-outline', 102],
        ['Фотографии', 'photo_23', 'mdi-cog-outline', 103],
        ['Сборник тезисов', 'thesis_23', 'mdi-cog-outline', 104],
      ],

      archive_24: [
        ['Программа', 'program_24', 'mdi-account-multiple-outline',105],
        ['Участники', 'users_24', 'mdi-cog-outline', 106],
        ['Фотографии', 'photo_24', 'mdi-cog-outline', 107],
        ['Сборник тезисов', 'thesis_24', 'mdi-cog-outline', 108],
      ],

      archive_25: [
        ['Программа', 'program_25', 'mdi-account-multiple-outline',109],
        ['Участники', 'users_25', 'mdi-cog-outline', 110],
        ['Фотографии', 'photo_25', 'mdi-cog-outline', 111],
        ['Сборник тезисов', 'thesis_25', 'mdi-cog-outline', 112],
      ],

      site_tab_new: [
        ['О форуме','home','mdi-cog-outline',2],
        ['Контакты','orgs','mdi-cog-outline',3],
        ['Программа','program','mdi-cog-outline',4],
        ['Школа молодых ученых','school','mdi-cog-outline',5],
        ['Участники','users','mdi-cog-outline',6],
        ['Тезисы','theses','mdi-cog-outline',7],
        ['Экскурсия','tour','mdi-cog-outline',8],
        // ['Фотографии','photo','mdi-cog-outline',8]
      ],
    }
  },
  beforeMount() {
    if (this.GETTERS_TOKEN === null && localStorage.getItem('token')) {
      this.getDataServicesStart()
    }
    // this.$i18n.locale = 'ru'

    // console.log('BEFOREE', this.$route)
    this.set_current_tab(this.$route.path)
  },
  methods: {
    ...mapActions([
      'logged', 
      'GET_PROFILE',
      'GET_SECTIONS',
    ]),
    ...mapMutations([
      'UPDATE_USER',
      'UPDATE_NAME_USER',
      'UPDATE_CURRENT_TAB',
    ]),

    choose_tab(tab_name){
      this.current_site_tab = 'tab_name'
      this.UPDATE_CURRENT_TAB(tab_name)
      switch(tab_name){
        
        case 'personal-data':
          if(localStorage.isLoggedIn)
            this.$router.push('/personal-data')
          else
            this.$router.push('/login')
          break;
        case 'home':
          this.$router.push('/')
          break;
        case 'orgs':
          this.$router.push('/orgs')
          break;
        case 'program':
          this.$router.push('/program')
          break;
        case 'users':
          this.$router.push('/users-list')
          break;
        case 'theses':
          this.$router.push('/theses')
          break;
        case 'tour':
          this.$router.push('/tour')
          break;
        case 'photo':
          this.$router.push('/photo')
          break;
        case 'school':
          this.$router.push('/school')
          break;
        case 'program_23':
          this.$router.push('/program-23')
          break;
        case 'users_23':
          this.$router.push('/users-list-23')
          break;
        case 'photo_23':
          this.$router.push('/photo-23')
          break;
        case 'thesis_23':
          this.$router.push('/thesis-23')
          break;
        case 'program_24':
          this.$router.push('/program-24')
          break;
        case 'users_24':
          this.$router.push('/users-list-24')
          break;
        case 'photo_24':
          this.$router.push('/photo-24')
          break;
        case 'thesis_24':
          this.$router.push('/thesis-24')
          break;
        case 'program_25':
          this.$router.push('/program-25')
          break;
        case 'users_25':
          this.$router.push('/users-list-25')
          break;
        case 'photo_25':
          this.$router.push('/photo-25')
          break;
        case 'thesis_25':
          this.$router.push('/thesis-25')
          break;
        default:
          break;
      }
    },

    switchArchive() {
      this.archive = !this.archive
    },
    async getDataServicesStart(val) {
      try {
        await this.GET_SECTIONS(CURRENT_MEETING_ID);

        await this.logged({ token: val });
        await this.GET_PROFILE(localStorage.isLoggedIn)  
        await this.UPDATE_NAME_USER(this.GETTERS_PROFILE.data.profiles[0].individual.last_name + ' ' + this.GETTERS_PROFILE.data.profiles[0].individual.first_name)
        await this.UPDATE_USER(this.GETTERS_PROFILE.data.profiles[0])


      } catch (ex) {
        console.log('APP ', ex);
      }
    },

    set_current_tab(val){

      this.is_history = false
      this.is_moder_view = false
    
      switch(val){
        case '/':
          this.current_site_tab = 'home'
          break;
        case '/moder-list':
          this.is_moder_view = true
          break;
        case '/orgs':
          this.current_site_tab = 'orgs'
          break;
        case '/program':
          this.current_site_tab = 'program'
          break;
        case '/program-23':
          this.current_site_tab = 'program_23'
          this.is_history = true
          this.hist_year = 2023
          break;
        case '/program-24':
          this.current_site_tab = 'program_24'
          this.is_history = true
          this.hist_year = 2024
          break;
        case '/program-25':
          this.current_site_tab = 'program_25'
          this.is_history = true
          this.hist_year = 2025
          break;
        case '/users-list':
          this.current_site_tab = 'users'
          break;
        case '/users-list-23':
          this.current_site_tab = 'users_23'
          this.is_history = true
          this.hist_year = 2023
          break;
        case '/users-list-24':
          this.current_site_tab = 'users_24'
          this.is_history = true
          this.hist_year = 2024
          break;
        case '/users-list-25':
          this.current_site_tab = 'users_25'
          this.is_history = true
          this.hist_year = 2025
          break;
        case '/theses':
          this.current_site_tab = 'theses'
          break;
        case '/tour':
          this.current_site_tab = 'tour'
          break;
        case '/school':
          this.current_site_tab = 'school'
          break;
        case '/photo-23':
          this.current_site_tab = 'photo_23'
          this.is_history = true
          this.hist_year = 2023
          break;
        case '/thesis-23':
          this.current_site_tab = 'thesis_23'
          this.is_history = true
          this.hist_year = 2023
          break;
        case '/photo':
          this.current_site_tab = 'photo'
          break;
        case '/photo-24':
          this.current_site_tab = 'photo_24'
          this.is_history = true
          this.hist_year = 2024
          break;
        case '/thesis-24':
          this.current_site_tab = 'thesis_24'
          this.is_history = true
          this.hist_year = 2024
          break;
        case '/photo-25':
          this.current_site_tab = 'photo_25'
          this.is_history = true
          this.hist_year = 2025
          break;
        case '/thesis-25':
          this.current_site_tab = 'thesis_25'
          this.is_history = true
          this.hist_year = 2025
          break;
        case '/personal-data':
        case '/login':
        case '/registration':
        case '/reset-password':
          this.current_site_tab = ''
          break;
        default:
          this.current_site_tab = 'home'
          break;

      }

    },
  },
  computed: {
    ...mapGetters(['GETTERS_LOGIN', 'GETTERS_PROFILE', 'GETTERS_TOKEN', 'GETTERS_OVERLAY'])
  },
  watch: {
    GETTERS_TOKEN(val) {
      localStorage.setItem('token', val)

      this.getDataServicesStart(val)
    },
    GETTERS_PROFILE(val) {
      // this.archive = val.data.profiles[0].individual.attached_old_proposals
      // if (val.data.profiles[0].individual.update_personal_data ){
      //   if (this.$route.path != '/personal-data') location.href = '/personal-data'
      // }
    },
    $route (to, from){

      // console.log('APP', to.path)
      this.set_current_tab(to.path)
    },
  }
};
</script>

<style scoped>
/* Target the inner image element that Vuetify creates */
.zoom-image >>> .v-image__image {
  transition: transform 0.3s ease-in-out;
}

/* Apply the zoom on hover */
.zoom-image:hover >>> .v-image__image {
  transform: scale(1.1); /* Adjust zoom factor here */
}
</style>

<style>
  .col-75 {
    max-width: 75%; 
    width: 75%;
  }
  .col-100 {
    max-width: 100%; 
    width: 100%;
  }

  .main-body-1 {
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
    min-width: 1024px;
    margin-top: 75px;
  }

  .main-body {
    min-width: 720px;
    max-width: 1200px;
    /* width: 100%; */
    height: 100%;
    /* position: fixed; */
    top: 0;
    left: 0;
    display: flex;
    /* align-items: center; */
    padding-top: 70px;
    align-content: center;
    justify-content: center;
    overflow: auto;
  }
</style>

<style lang="scss">

  $success-toast-color: #4CAF50;
  $error-toast-color: #FF5252;
  $warning-toast-color: #FFC107;
  $default-toast-color: grey;

  *, body, html {
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    
  }

  .v-card__title{
    word-break: break-word !important;
  }

  .main-container{
    margin-right: 55px !important;
    margin-bottom: 60px !important;
    margin-left: 5px !important;
    border-radius: 13px!important;

  }
  .p-l-15 {
    padding-left: 15px;
  } 
  .p-r-15 {
    padding-right: 15px;
  }
  .switch-login {
    position: absolute;
    top: 25px;
    left: 54%;
  }
  .switch{
    margin-top: 0;
    margin-left:10px;

    .v-input--selection-controls {
        margin-top: 0 !important;
    }
  }

  .switch__current-lang {
    padding-top:3px;
    font-size: 16px;
    margin-right: 10px;
    color: rgba(0, 0, 0, 0.6);
  }

  .help-name-page {
    position: absolute;
    top: 6%;
    right: 10px;
    color: #15336D;
    z-index: 1;
  }
  .mb-12.wrapper.v-card.v-sheet.theme--light.white{
    box-shadow: none;
  }
  .v-stepper__header{
    box-shadow: none;
  }
  .theme--light.v-stepper.v-stepper__header.v-divider{
    background-color: #15336d;
  }
  .v-application .primary{
    background-color: #15336d !important;
  }
  *, body, html{
    box-shadow: none;
  }
  .v-stepper.header-stepper.theme--light{
    box-shadow: none;
  }
  .v-application--is-ltr .v-stepper__label {
    text-align: center !important;
  }
  .Vue-Toastification__toast {
    min-height: 54px !important;
    padding: 16px 24px !important;
    background: white !important;
  }

  .Vue-Toastification__toast--warning,
  .Vue-Toastification__close-button {
    color: $warning-toast-color !important;
  }
  .Vue-Toastification__toast--success,
  .Vue-Toastification__close-button {
    color: $success-toast-color !important;
  }
  .Vue-Toastification__toast--error,
  .Vue-Toastification__close-button {
    color: $error-toast-color !important;
  }
  .Vue-Toastification__toast--info,
  .Vue-Toastification__close-button {
    color: $default-toast-color !important;
  }
  .error-input {
    border: 2px solid #ff5252 !important;
    color: #ff5252;
  }
</style>
